<div class="search_game" [ngClass]="{'search_game--sticky': sticky, 'search_game--show': selectedGames || showDropdownFilter}">
  <form class="slot-game_search slotsGameSearch clearfix">

    <!-- Search Input Wrapper -->
    <div class="slot-game_search--wrap searchGameWrap">
      <div class="slot-game_search--inputwrap">
        <i class="icon icon-search-1" (click)="enableSearch()"></i>
        <i class="icon icon-close-simplified" (click)="closeSearch()"></i>
        <div class="controls">
          <input [(ngModel)]="searchInput" name="searchInput" class="form-control {{getSearchInputVal()}}"
          id="searchInput"
          (input)="searchGames($event.target.value)"
          placeholder="{{'gamingComp.gaming26' | translate}}"/>
          <!-- <label for="searchInput">Games or Providers</label> -->
          <!-- <label for="searchInput">{{'gamingComp.gaming26' | translate}}</label> -->
        </div>
      </div>
      <div class="close_filter--Wrapper">
        <span class="slot-game_search--close-label" (click)="closeSearch()">{{'gamingComp.close' | translate}}</span>
        <!-- *ngIf="page === 'footersticky'" Confirm and remove later-->
        <span  class="slot-game_search--filter-label" (click)="toggleDropdownFilter()">{{'gamingComp.filter' | translate}}</span>
      </div>
    </div>

    <!-- Search Results Wrapper -->
    <div class="search_results" *ngIf="selectedGames">

      <ng-container *ngIf="selectedGames && selectedGames.length > 0">
        <!--Last played games code starts-->
        <ng-container>
          <div class="recently-played--games" *ngIf="userLogin && recentlyPlayedGames?.length">
            <h5 class="search_results--subHeading">{{'gamingComp.recentlyPlayedGames' | translate}}</h5> 
            <div class="recently-played--lists">
              <ul>
                <li *ngFor="let gameItem of recentlyPlayedGames;">
                  <div class="game-img" (click)="navigateToGames(gameItem)" [ngStyle]="{'background-image': 'url(' + siteUrlPath+ '/' + gameUrlPath + '/' + gameItem.gameCode + '/' + gameItem.gameCode + '.jpg)'}">

                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="search_results--lists" (scroll)="loadMoreSearchResult($event)">
              <div class="search_results--list" *ngFor="let game of selectedGames">
                <div class="search_results--img" 
                  [ngStyle]="{'background-image': 'url(' + siteUrlPath+ '/' + gameUrlPath + '/' + game.gameCode + '/' + game.gameCode + '.jpg)'}">
                </div>
              </div>
            </div> -->
          </div>
        </ng-container>
        <!--ends here-->

        <ng-container *ngIf="true">
          <h5 class="search_results--subHeading">{{'gamingComp.games' | translate}}</h5>  
          <div class="search_results--lists" (scroll)="loadMoreSearchResult($event)">
            <div class="search_results--list" *ngFor="let game of selectedGames">
              <div class="search_results--img" 
              [ngStyle]="{'background-image': 'url(' + siteUrlPath+ '/' + gameUrlPath + '/' + game.gameCode + '/' + game.gameCode + '.jpg)'}"></div>
              <div class="search_results--desc">
                <h4 class="search_results--title">{{game.name}}</h4>
                <h5 class="search_results--subtitle">{{game.vendorDisplayName}}</h5>
              </div>
              <button class="search_results--button" (click)="navigateTo()" *ngIf="!userLogin">{{'gamingComp.gaming21' | translate}}</button>
              <button class="search_results--button" (click)="navigateToGames(game)" *ngIf="userLogin">{{'gamingComp.gaming18' | translate}}</button> 
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showVendorSearchResults">
          <h5 class="search_results--subHeading">{{'gamingComp.provider' | translate}}</h5>  
          <div class="search_results--lists search_results--providers">
            <div class="search_results--list">
              <div class="search_results--img"
              [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + mediaUrlPath + '/providers/' + providerCode + '.png)'}"></div>
              <div class="search_results--desc">
                <h4 class="search_results--title">{{providerResult}}</h4>
                <h5 class="search_results--subtitle">{{providerResultLength}} {{'gamingComp.games' | translate}}</h5>
              </div>
              <button class="search_results--button" (click)="navigateToVendorGames(providerCode)">{{'gamingComp.viewall' | translate}}</button>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="selectedGames && selectedGames.length === 0">
        <div class="search_results--nogames">
          <p>{{'gamingComp.gaming28' | translate}}</p>
        </div>
      </ng-container>
    </div>
  </form>

  <div class="dropdown" [ngClass]="showDropdownFilter ? 'show' : 'hide'">
    <div class="game_filter_dropdown MobProviderfilter--dropdown">
      <app-lobby-filters [isMobileFilter]="true" [gameProviderMap]="gameProviderMap"
        (hideFilterDropDown)="toggleDropdownFilter($event)"></app-lobby-filters>
      <!-- <app-lobby-sorting [isMobileFilter]="true" (hideFilterDropDown)="toggleDropdownFilter($event)"></app-lobby-sorting> -->
    </div>
  </div>
</div>